/** Base URL for Little Monkey's map server */
export const mapsLittleMonkeyBaseUrl = "https://maps.littlemonkey.co.nz";

/** Endpoint for Little Monkey's address autocomplete service */
export const addressAutocompleteEndpoint = "/complete";

/** Endpoint for Little Monkey's geo location via IP service */
export const geoIpEndpoint = "/geoip";
